import { render, staticRenderFns } from "./template-read.vue?vue&type=template&id=7fa60d75&scoped=true"
import script from "./template-read.vue?vue&type=script&lang=ts"
export * from "./template-read.vue?vue&type=script&lang=ts"
import style0 from "./template-read.vue?vue&type=style&index=0&id=7fa60d75&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa60d75",
  null
  
)

export default component.exports